import React from 'react';
import BenefitItem from './BenefitItem';
import {OverviewBenefits} from '../../../reducers/overview';

//@ts-ignore
import styles from './BenefitsSection.pcss';

export type BenefitsSectionProps = OverviewBenefits;

const BenefitsSection: React.FC<BenefitsSectionProps> = ({title, benefits = []}) => (
    <div className={styles.section}>
        <div className={styles.benefits}>
            {benefits.map((item, key) => (
                <BenefitItem key={key} {...item} />
            ))}
        </div>
    </div>
);

export default BenefitsSection;
